import { IPipeline } from '../../interfaces/ipipeline';
import { ArtificialLiftType } from '../artificial-lift-type';
import { Asset } from '../asset';
import { Commodity } from '../commodity';
import { GISStatus } from '../g-i-s-status';
import { PipelineType } from '../pipeline-type';

export class PipelineBase {
  PipelineId: number;
  AssetId: number | null;
  PipelineNumber: number;
  PipelineTypeId: number | null;
  CommodityId: number | null;
  PipelineOriginatingAssetId: string | null;
  OriginationAssetDescription: string | null;
  PipelineTerminatingAssetId: number | null;
  TerminationAssetDescription: string | null;
  PipelinePressureMAOP: number | null;
  NominalSize: number | null;
  Material: string | null;
  CathodicProtection: boolean | null;
  Burried: boolean | null;
  InServiceDate: Date | null;
  OpStatusId: number | null;
  GatheringSystemId: number | null;
  GISLength: number | null;
  JV: boolean | null;
  ConstructionStatusId: number | null;
  GISStatusId: number | null;
  PipeSpecificationId: number | null;
  EstimatedLength: number | null;
  ArtificialLiftTypeId: number | null;
  Length: number | null;
  PipelineOriginatingLocation: object | null;
  PipelineTerminatingLocation: object | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ArtificialLiftType?: ArtificialLiftType;
  Asset?: Asset;
  Commodity?: Commodity;
  GISStatus?: GISStatus;
  PipelineType?: PipelineType;

  constructor(item?: IPipeline) {
    if (item) {

      this.PipelineId = item.PipelineId;
      this.AssetId = item.AssetId;
      this.PipelineNumber = item.PipelineNumber;
      this.PipelineTypeId = item.PipelineTypeId;
      this.CommodityId = item.CommodityId;
      this.PipelineOriginatingAssetId = item.PipelineOriginatingAssetId;
      this.OriginationAssetDescription = item.OriginationAssetDescription;
      this.PipelineTerminatingAssetId = item.PipelineTerminatingAssetId;
      this.TerminationAssetDescription = item.TerminationAssetDescription;
      this.PipelinePressureMAOP = item.PipelinePressureMAOP;
      this.NominalSize = item.NominalSize;
      this.Material = item.Material;
      this.CathodicProtection = item.CathodicProtection;
      this.Burried = item.Burried;
      this.InServiceDate = item.InServiceDate ? new Date(item.InServiceDate) : null;
      this.OpStatusId = item.OpStatusId;
      this.GatheringSystemId = item.GatheringSystemId;
      this.GISLength = item.GISLength;
      this.JV = item.JV;
      this.ConstructionStatusId = item.ConstructionStatusId;
      this.GISStatusId = item.GISStatusId;
      this.PipeSpecificationId = item.PipeSpecificationId;
      this.EstimatedLength = item.EstimatedLength;
      this.ArtificialLiftTypeId = item.ArtificialLiftTypeId;
      this.Length = item.Length;
      this.PipelineOriginatingLocation = item.PipelineOriginatingLocation;
      this.PipelineTerminatingLocation = item.PipelineTerminatingLocation;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ArtificialLiftType = new ArtificialLiftType(item.ArtificialLiftType);
      this.Asset = new Asset(item.Asset);
      this.Commodity = new Commodity(item.Commodity);
      this.GISStatus = new GISStatus(item.GISStatus);
      this.PipelineType = new PipelineType(item.PipelineType);
    }
  }
}